/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import { getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { PageHitCountApi } from '../../../../../shared/Helper';
import { useLocation } from 'react-use';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import ReactPaginate from 'react-paginate';
import { printTable } from '../../../../../utils/tableExportUtils';
import { useDispatch, useSelector } from 'react-redux';
const CMSMenuList = () => {
  const [apiData, setApiData] = useState([]);
  const [searchFiltersList, setSearchFiltersList] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [itemLevel, setItemLevel] = useState('');
  const [checkedRecords, setCheckedRecords] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const isActive = useSelector((state) => state.toggle.isActive);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token && !epUser) {
      navigate('/managementLogin');
    }
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const SearchFilter = {
    ItemLevelName: itemLevel,
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      `CMSMenu/GetCMSMenuFilterListAsync?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
      {},
      'application/json',
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const changePage = async ({ selected }) => {
    const newPage = selected + 1;

    try {
      const response = await postAsync(
        `CMSMenu/GetCMSMenuFilterListAsync?page=${newPage}&pageSize=${pageOptions.pageSize}`,
        {},
        'application/json',
      );
      setApiData(response?.data);
      setPageCount(response.page);
      setNext(selected + 1);
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const getSearchFilters = async () => {
    await getAsync('CMSMenu/GetActiveCMSMenuListAsync')
      .then((response) => {
        setSearchFiltersList(response);
      })
      .catch((error) => {
        toast.error(t('Record Not Found.'));
      });
  };

  const getPaginationList = async () => {
    await postAsync(
      `CMSMenu/GetCMSMenuFilterListAsync?page=${pageOptions.pageNo}&pageSize=${pageOptions.pageSize}`,
      SearchFilter,
      'application/json',
    )
      .then((response) => {
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }

        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleAllCheckboxChange = (e, index) => {
    const isChecked = e.target.checked;
    if (index === 'selectAll') {
      // Handle "Select All" checkbox
      setSelectAllChecked(isChecked);
      setCheckedRecords((prevCheckedRecords) => {
        const updatedRecords = {};
        apiData.forEach((data, dataIndex) => {
          updatedRecords[dataIndex] = {
            isChecked,
            menuItemID: data.menuItemID,
            activeYNID: data.activeYNID,
          };
        });
        return updatedRecords;
      });
    } else {
      // Handle individual checkboxes
      setCheckedRecords((prevCheckedRecords) => {
        const updatedRecords = { ...prevCheckedRecords };
        updatedRecords[index] = {
          isChecked: isChecked || false, // Ensure a default value
          menuItemID: apiData[index]?.menuItemID,
          activeYNID: apiData[index]?.activeYNID,
        };
        return updatedRecords;
      });
    }
  };

  const handleCheckboxChange = (e, index) => {
    const isChecked = e.target.checked;
    setCheckedRecords((prevCheckedRecords) => {
      const updatedRecords = { ...prevCheckedRecords };
      updatedRecords[index] = {
        isChecked,
        menuItemID: apiData[index]?.menuItemID,
        activeYNID: apiData[index]?.activeYNID,
      };
      return updatedRecords;
    });
  };

  const handleActive = (e, id) => {
    onActive(e, id);
  };
  const handleInActive = (e, id) => {
    onInActive(e, id);
  };

  const onActive = async (e, id) => {
    e.preventDefault();
    const bodyActive = {
      menuItemID: id,
      activeYNID: true,
    };
    await putAsync('CMSMenu/ActiveAndDeActiveCMSMenuAsync', bodyActive)
      .then(() => {
        // setSwitchButtonValue(switchButtonValue)
        getData();
        toast.success(t('Active Successfully'));
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const onInActive = async (e, id) => {
    e.preventDefault();
    const bodyInActive = {
      menuItemID: id,
      activeYNID: false,
    };
    await putAsync('CMSMenu/ActiveAndDeActiveCMSMenuAsync', bodyInActive)
      .then(() => {
        // setSwitchButtonValue(!switchButtonValue)
        getData();
        toast.success(t('Deactivated Successfully'));
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const onUpdate = async (e) => {
    e.preventDefault();
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row items={apiData} key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.ar_SA}</Table.Cell>
        <Table.Cell>{data?.en_US}</Table.Cell>
        <Table.Cell>{data?.menuLevelID}</Table.Cell>
        <Table.Cell>
          {data?.activeYNID == true ? (
            <label
              style={{
                backgroundColor: 'lightgreen',
                fontWeight: 'bold',
                color: 'green',
                padding: '5px',
                width: '70px',
                textAlign: 'center',
                borderRadius: '5px',
              }}
            >
              {t('Active')}
            </label>
          ) : (
            <label
              style={{
                backgroundColor: 'lightpink',
                fontWeight: 'bold',
                color: 'red',
                padding: '5px',
                width: '70px',
                textAlign: 'center',
                borderRadius: '5px',
              }}
            >
              {t('Inactive')}
            </label>
          )}
        </Table.Cell>
        <Table.Cell>
          <div className="flex items-center">
            <input
              checked={data?.activeYNID == true}
              onChange={(e) => handleActive(e, data?.menuItemID)}
              className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
              id={`react-switch-new-${data?.menuItemID}`}
              name={`react-switch-new-${data?.menuItemID}`}
              type="radio"
            />
            <label>{t('Active')}</label>
          </div>

          <div className="flex items-center">
            <input
              checked={data?.activeYNID == false}
              onChange={(e) => handleInActive(e, data?.menuItemID)}
              className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
              id={`react-switch-new-${data?.menuItemID}`}
              name={`react-switch-new-${data?.menuItemID}`}
              type="radio"
            />
            <label>{t('Inactive')}</label>
          </div>
        </Table.Cell>
      </Table.Row>
    );
  });

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Item Name Arabic': item.ar_SA,
      'Item Name English': item.en_US,
      'Item Level': item.menuLevelID,
      Status: item?.activeYNID == true ? t('Active') || 'N/A' : t('Inactive') || 'N/A',
    }));
    downloadCSV(filteredData, 'Cms Menu List');
  };
  const handlePrint = (e) => {
    e.preventDefault();

    // Column configuration
    const columns = [
      {
        header: t('sNo'),
        accessor: (row, index) => index + 1,
      },
      {
        header: t('Item Name Arabic'),
        accessor: (row) => (isActive ? row?.ar_SA : row?.ar_SA),
      },
      {
        header: t('Item Name English'),
        accessor: (row) => (isActive ? row?.en_US : row?.en_US),
      },
      {
        header: t('Item Level'),
        accessor: (row) => (isActive ? row?.menuLevelID || 'N/A' : row?.menuLevelID || 'N/A'),
      },
      {
        header: t('Status'),
        accessor: (row) =>
          isActive
            ? row?.activeYNID === true
              ? t('Active')
              : t('Inactive')
            : row?.activeYNID === true
              ? t('Active')
              : t('Inactive'),
      },
    ];

    // Call the reusable print function
    printTable({
      data: apiData || [],
      isRTL: isActive, // isActive true = Arabic = RTL
      t: t,
      title: `${t('CMS Menu')} ${t('list')}`,
      columns: columns,
      onBeforePrint: () => {
        console.log('Printing started...');
        // toast.info(t('Preparing print preview...'));
      },
      onAfterPrint: () => {
        console.log('Printing completed');
      },
      styles: {
        customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `,
      },
    });
  };
  // const handlePrint = (e) => {
  //   e.preventDefault();

  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('CMS Menu')} ${t('list')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Item Name Arabic`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Item Name English`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Item Level`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       ?.map((data, index) => {
  //         const sno = (next - 1) * pageOptions.pageSize + index + 1;
  //         return `
  //       <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //         <td style="padding: 5px; border: 1px solid #ddd;">${sno}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.ar_SA || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.en_US}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${data?.menuLevelID || 'N/A'}</td>
  //         <td style="padding: 5px; border: 1px solid #ddd;">${`${data?.activeYNID == true ? t('Active') || 'N/A' : t('Inactive') || 'N/A'}`}</td>
  //       </tr>
  //     `;
  //       })
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   const style = document.createElement('style');
  //   style.textContent = `
  //    @media print {
  //     body > * {
  //       display: none !important;
  //     }
  //     .tableData {
  //       display: block !important;
  //       position: static !important;
  //     }
  //     }
  // `;
  //   document.head.appendChild(style);

  //   setTimeout(() => {
  //     window.print();

  //     document.body.removeChild(tableContainer);
  //     document.head.removeChild(style);

  //     setTimeout(() => {
  //       document.querySelectorAll('body > *').forEach((el) => {
  //         el.style.display = 'block';
  //       });
  //     }, 100);
  //   }, 500);

  //   return 'success';
  // };
  return (
    <div className="">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="row justify-center py-5 mt-3">
            <div className="col-lg-11">
              <div className="shadow-md  rounded-md">
                <div className="card-header p-2 text-center">
                  <h3 className="font-bold text-2xl text-center text-customgreen">
                    {t('CMS Menu')} {t('list')}
                  </h3>
                </div>
                <div className="card-body p-10">
                  <div className="row">
                    <div className="form-group">
                      <label>{t('Item Level')}</label>
                      <input
                        type="text"
                        placeholder={t('Item Level')}
                        className=" border border-customgreen text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-customgreen block w-full p-2.5"
                        onChange={(e) => setItemLevel(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group px-6 pt-7 text-center">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={(e) => handleSearch(e)}
                        >
                          {t('Search')}
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-12 flex justify-center md:justify-end gap-2 mt-5">
                      <div className="flex justify-center md:flex-row md:justify-end gap-2">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={handlePrint}
                          // disabled={ !(loader === false) }
                        >
                          {<span>{t('Print')}</span>}
                        </button>
                      </div>
                      <div className="flex justify-center md:flex-row md:justify-end gap-2">
                        <button
                          className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={(e) => handleOnExport(e)}
                        >
                          {t('Export')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <Form>
            <InputGroup className="my-3">
              <Form.Control
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search Record"
              />
            </InputGroup>
          </Form> */}
            {isLoad ? (
              <LoadingAnimation
                imageStyling={''}
                styling={'flex items-center py-5 align-middle justify-center space-x-2'}
              />
            ) : (
              apiData?.length > 0 && (
                <div className="col-lg-11 text-center pt-9">
                  <div className="relative overflow-x-auto  shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                        <Table.Row className=" whitespace-nowrap">
                          {/* <Table.HeaderCell>
                  <input
                    type="checkbox"
                    name="checked"
                    checked={selectAllChecked}
                    onChange={(e) => handleAllCheckboxChange(e, 'selectAll')}
                  />
                </Table.HeaderCell> */}

                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Item Name Arabic')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Item Name English')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Item Level')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>{displayRecords}</Table.Body>
                    </Table>
                  </div>

                  <div className="flex flex-row px-12 justify-between">
                    <Menu pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                  {/* <div className="col-lg-12" style={{ float: 'right', width: '120px' }}>
            <button className="btn btn-success form-group" onClick={(e) => onUpdate(e)}>
              {t('Update')}
            </button>
          </div> */}
                </div>
              )
            )}
            {datanotfound && <DataNotFound />}
          </div>
        </>
      )}
    </div>
  );
};

export default CMSMenuList;
